import { Pagination } from '@/constants/pagination';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FactoryState = {
  dataAllFactory: FactoryType[];
  detailFactory?: FactoryDetailType;
  dataAllUserInFactory: UserInFactoryType[];
  pagination: PaginationAPI;
  totalElements?: number;
  worksheets: any[];
  worksheetsTotalPages: number;
};

export const factoryInitialState: FactoryState = {
  dataAllFactory: [],
  dataAllUserInFactory: [],
  pagination: {
    pageNumber: Pagination.pageNumber,
    totalPages: 0,
    totalElements: 0,
    pageSize: Pagination.pageSize,
  },
  worksheets: [],
  worksheetsTotalPages: 1,
};

export const slice = createSlice({
  name: 'factory',
  initialState: factoryInitialState,
  reducers: {
    setListFactoryAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: FactoryType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllFactory = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setListUserInFactoryAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: UserInFactoryType[];
        pagination?: PaginationAPI;
        totalElements?: number;
      }>,
    ) {
      state.dataAllUserInFactory = payload.data;
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setWorksheetsAction(state, { payload }: PayloadAction<{ data: any[]; totalPages: number }>) {
      state.worksheets = payload.data;
      state.worksheetsTotalPages = payload.totalPages;
    },

    appendWorksheetsAction(state, { payload }: PayloadAction<{ data: any[]; totalPages: number }>) {
      const existingIds = new Set(state.worksheets.map((w: any) => w.id));
      const newItems = payload.data.filter((w: any) => !existingIds.has(w.id));
      state.worksheets = [...state.worksheets, ...newItems];
      state.worksheetsTotalPages = payload.totalPages;
    },

    resetWorksheetsAction(state) {
      state.worksheets = [];
      state.worksheetsTotalPages = 1;
    },

    deleteFactoryAction(state, { payload }: PayloadAction<string>) {
      state.dataAllFactory = state.dataAllFactory.filter((item) => !payload.includes(item.id!));
    },

    addFactoryAction(state, { payload }: PayloadAction<FactoryType>) {
      state.dataAllFactory = [payload, ...state.dataAllFactory];
      state.pagination = {
        ...state.pagination,
        pageSize: state.pagination.pageSize + 1,
        totalElements: state.pagination.totalElements + 1,
      };
    },

    updateFactoryAction(state, { payload }: PayloadAction<FactoryType>) {
      state.dataAllFactory = state.dataAllFactory.map((item) => {
        if (item?.id === payload?.id) {
          return payload;
        }
        return item;
      });
    },

    setDetailFactoryAction(
      state,
      { payload }: PayloadAction<{ detailFactory: FactoryDetailType }>,
    ) {
      state.detailFactory = payload.detailFactory;
    },
  },
});

export const {
  setListFactoryAction,
  setWorksheetsAction,
  appendWorksheetsAction,
  resetWorksheetsAction,
  deleteFactoryAction,
  addFactoryAction,
  updateFactoryAction,
  setDetailFactoryAction,
  setListUserInFactoryAction,
} = slice.actions;

export default slice.reducer;
